import type { FunctionComponent, ReactElement } from 'react'
import React, { createContext } from 'react'

const ContentContext = createContext<ReactElement | null>(null)

export const RouterOutletProvider = ContentContext.Provider

export const RouterOutlet: FunctionComponent = () => {
  return <ContentContext.Consumer>{value => value}</ContentContext.Consumer>
}
